export default __webpack_public_path__ + "static/media/keyboard_key_3.430b08ad.png";